import { Col, Divider, Row } from "antd";
import { FormattedMessage } from "react-intl";

const ThereMore = ({ inModal }) => {
  return (
    <div
      className="roi--patient-exp-acq-container"
      style={{ maxWidth: inModal ? "100%" : "65%" }}
    >
      <div className="roi--patient-exp-acq-title">
        <span>
          <FormattedMessage id="thereMore" />
        </span>
      </div>

      <Row gutter={16} style={{ marginTop: "2rem", padding: "0 1rem" }}>
        <Col span={12}>
          <span className="roi--there-more-title">
            <FormattedMessage id="jobSatisfaction" />
          </span>
          <Divider className="roi--there-more-underline" />
          <p className="roi--there-more-text">
            <FormattedMessage id="jobSatisfactionInfo" />
          </p>
        </Col>
        <Col span={12}>
          <span className="roi--there-more-title">
            <FormattedMessage id="additionalRevenuesOpportunities" />
          </span>
          <Divider className="roi--there-more-underline" />
          <p className="roi--there-more-text">
            <FormattedMessage id="additionalRevenuesOpportunitiesInfo" />
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default ThereMore;
